import { InitOverrideFunction, SettingsApi } from "../../../@api";

import { IStoreContext } from "../../stores/StoreContext";
import { SettingsApiService } from "../ApiServices/SettingsApiService";
import GenericService from "../GenericService";

export class SettingsService extends GenericService<SettingsApi, SettingsApiService> {
  constructor(storeContext: IStoreContext) {
    super(storeContext, SettingsApi, SettingsApiService);
  }

  public async shouldPersistChat(initOverrides?: RequestInit | InitOverrideFunction): Promise<boolean> {
    const response = await this.apiService.settingsShouldPersistChatGet(initOverrides);
    this.storeContext.settingsStore.setPersistChat(response);
    return response;
  }

  public async acceptTermsOfUse(): Promise<string> {
    throw new Error("Not implemented");
  }
}
